import React from 'react';

import PageContainer from '../PageContainer';

const App = () => {
    return (
        <PageContainer />
    );
};

export default App;
